const TC = "TAXES/USER";

export const LOAD_TAXPAYER = `${TC}/LOAD_TAXPAYER`;
export const LOAD_CONTRIBUTOR = `${TC}/LOAD_CONTRIBUTOR`;
export const SET_DUPLICATE_DATA = `${TC}/SET_DUPLICATE_DATA`;
